import { render, staticRenderFns } from "./newComManagementMessage.vue?vue&type=template&id=028416b2&scoped=true"
import script from "./newComManagementMessage.vue?vue&type=script&lang=js"
export * from "./newComManagementMessage.vue?vue&type=script&lang=js"
import style0 from "./newComManagementMessage.vue?vue&type=style&index=0&id=028416b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028416b2",
  null
  
)

export default component.exports